import { createI18n } from "vue-i18n";
import en from "@/i18n/locales/en.json";
import ru from "@/i18n/locales/ru.json";
import zh from "@/i18n/locales/zh.json";

export default createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: { en, ru, zh },
  legacy: false,
  globalInjection: true,
});
